const API = process.env.REACT_APP_API_URL;

export const openRazorpay = async ({ amount, plan }) => {
    try {
        const res = await fetch(`${API}/payment/create-order`, {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ amount: Math.round(amount) })
        });

        if (!res.ok) throw new Error("Server error");

        const order = await res.json();

        const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            currency: order.currency,
            name: "Adeya IMS",
            description: plan,
            order_id: order.id,
            handler: async (response) => {
                try {
                    const vr = await fetch(`${API}/payment/verify`, {
                        method: 'POST',
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(response)
                    });

                    const out = await vr.json();
                    if (out.success) {
                        alert("✅ Payment Successful!");
                        window.location.href = "/pricing?payment=success";
                    } else {
                        alert("Payment received. Verification pending.");
                    }
                } catch (error) {
                    alert("Payment received. Verification pending.");
                }
            },
            modal: {
                ondismiss: () => {
                    alert("Payment Cancelled");
                }
            },
            theme: { color: '#2563eb' }  // Blue theme
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    } catch (error) {
        console.error("Razorpay error:", error);
        alert("Failed to initiate payment. Please try again.");
    }
};